import { mapActions, mapGetters, mapState } from 'vuex';
import balanceHistory from '@/components/balance-history/balance-history.vue';
import exportHistory from '@/components/export-history/export-history.vue';
import formSelect from '@/components/forms/select/select.vue';
import { ALL_YEARS_OPTION, ALL_TYPES_OPTION } from '@/store/modules/profile';


export default {
  props: {
    showExport: Boolean,
  },
  components: {
    balanceHistory,
    exportHistory,
    formSelect,
  },
  data() {
    return {
      cancelCounter: 0,
      isResetting: false,
      typeOptions: [],
      yearsOptions: [],
      filter: {
        type: ALL_TYPES_OPTION,
        year: ALL_YEARS_OPTION,
      },
    };
  },
  computed: {
    ...mapState('profile', ['pendingHistory', 'transactionHistory']),
    ...mapGetters('profile', ['transactionFilters']),
    items() {
      return this.transactionHistory.data === null
        ? []
        : [
          ...this.pendingHistory,
          ...this.transactionHistory.data,
        ];
    },
    canLoadMore() {
      return this.transactionHistory.canLoadMore;
    },
    isExportAvailable() {
      return this.showExport &&
        this.transactionHistory &&
        this.transactionHistory.data &&
        this.transactionHistory.data.length > 0;
    },
  },
  watch: {
    'filter.type': function watchType() {
      if (this.isResetting) return;
      this.handleFilters();
    },
    'filter.year': function watchYear() {
      if (this.isResetting) return;
      this.handleFilters();
    },
  },
  methods: {
    ...mapActions('profile', ['getTransactionHistory', 'resetTransactionHistory']),
    resetFilters() {
      this.isResetting = true;
      this.filter.type = ALL_TYPES_OPTION;
      this.filter.year = ALL_YEARS_OPTION;
      setTimeout(() => { this.isResetting = false; }, 100);
    },
    handleFilters() {
      const canLoadMore = this.transactionHistory.canLoadMore;
      this.resetTransactionHistory();
      if (canLoadMore) this.loadHistory();
    },
    loadHistory() {
      if (this.transactionHistory.canLoadMore) {
        const payload = {
          type: this.filter.type.value,
          year: this.filter.year.value,
        };
        this.getTransactionHistory(payload);
      }
    },
    modalExport() {
      this.$emit('export', 'deposit-withdrawals');
    },
    onItemCancelled() {
      this.resetFilters();
      this.resetTransactionHistory();
      this.cancelCounter += 1;
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/account/history/transactions/transactions.js